import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useLocation } from 'react-router'
import { Dropdown, DropdownOption } from '@vista-digital/occ-ui'
import type { IndexKey } from '@vista-digital/utilities'
import { cmsDataService, navigationService } from '../../../services'

export const LocationPicker: React.FC = () => {
    const locations = useMemo(() => cmsDataService.get().header?.locations, [])

    const page = useLocation()

    const locationOptions: DropdownOption[] = useMemo(
        () =>
            locations?.map(location => ({
                text: location.name,
                value: location.url,
            })) ?? [],
        [locations]
    )

    const [selectedLocation, setSelectedLocation] = useState<IndexKey | undefined>(() => {
        return locationOptions.find(location => page.pathname.includes(location.value.toString()))?.value || undefined
    })

    useEffect(() => {
        const newLocation = locationOptions.find(location => page.pathname.includes(location.value.toString()))

        if (newLocation) return setSelectedLocation(newLocation.value)
        if (selectedLocation && !newLocation) return setSelectedLocation(undefined)
    }, [page, locationOptions])

    const handleLocationSelection = useCallback(
        (value: IndexKey) => {
            setSelectedLocation(value)
            navigationService.goTo(value.toString())
        },
        [setSelectedLocation]
    )

    return (
        <Dropdown
            enableSearch={false}
            placeholder="Select a location"
            options={locationOptions}
            value={selectedLocation}
            onChangeValue={handleLocationSelection}
            buttonIconName="arrowDown"
        />
    )
}

export default LocationPicker
